// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"glacier-and-wave-2-teaser_productcontent__j5QAX"};